"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON"));

var _Map = _interopRequireDefault(require("ol/Map"));

var _Projection = _interopRequireDefault(require("ol/proj/Projection"));

var _react = _interopRequireWildcard(require("react"));

var _View = _interopRequireDefault(require("ol/View"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _constants = require("./constants");

var _propTypes = require("prop-types");

var _proj = require("ol/proj");

function isSame(obj1, obj2) {
  if (!obj1 && !obj2) {
    return true;
  } else if (!obj1 || !obj2) {
    return false;
  }

  return (0, _lodash["default"])(obj1, obj2);
}

var ID = "@planet/layers#".concat(Date.now());
var format = new _GeoJSON["default"]();

var Map =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Map, _Component);

  function Map(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Map);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Map).call(this, props));
    var options = Object.assign({
      logo: false,
      controls: [],
      view: new _View["default"]({
        multiWorld: _this.props.multiWorld,
        projection: _this.props.view && _this.props.view.projection || _constants.WEB_PROJECTION
      })
    }, _this.props.constructorOptions);
    _this.map = new _Map["default"](options);
    return _this;
  }

  (0, _createClass2["default"])(Map, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        map: this.map
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.map.setTarget(this.viewport);
      this.map.on('click', this.onMapClick.bind(this));
      this.map.on('moveend', this.onMapMoveEnd.bind(this));
      this.map.on('pointermove', this.onMapPointerMove.bind(this));
      this.map.getInteractions().forEach(function (interaction) {
        interaction.set(ID, true);
      });
      this.updateInteractions();
      this.updateView(this.props);

      if (this.props.innerRef) {
        this.props.innerRef(this.map);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.innerRef) {
        this.props.innerRef(this.map);
      }

      if (!isSame(this.props.animation, prevProps.animation) || !isSame(this.props.view, prevProps.view)) {
        // Create a new view if the projection has changed
        if (this.props.view && this.props.view.projection && !isSame(this.props.view.projection, prevProps.view.projection)) {
          var newView = new _View["default"]({
            multiWorld: this.props.multiWorld,
            projection: this.props.view.projection || prevProps.view.projection.getCode()
          });
          this.map.setView(newView);
        }

        this.updateView(this.props);
      }

      if (!!this.props.onViewChange !== !!prevProps.onViewChange) {
        this.updateInteractions();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.map.setTarget(null);

      if (this.props.innerRef) {
        this.props.innerRef(null);
      }
    }
  }, {
    key: "onMapPointerMove",
    value: function onMapPointerMove(event) {
      if (this.props.onMapPointerMove) {
        this.props.onMapPointerMove(event);
      }
    }
  }, {
    key: "onMapClick",
    value: function onMapClick(event) {
      var _this2 = this;

      if (this.props.onMapClick) {
        var view = this.map.getView();
        var projection = view.getProjection();
        this.props.onMapClick({
          coordinate: (0, _proj.toLonLat)(event.coordinate, projection),
          pixel: event.pixel,
          getFeatures: function getFeatures() {
            var features = _this2.map.getFeaturesAtPixel(event.pixel);

            if (!features) {
              return [];
            }

            var featureCollection = format.writeFeaturesObject(features, {
              featureProjection: projection
            });
            return featureCollection.features;
          }
        });
      }
    }
  }, {
    key: "onMapMoveEnd",
    value: function onMapMoveEnd() {
      if (this.props.onViewChange) {
        var view = this.map.getView();
        var projection = view.getProjection();
        var extent = view.calculateExtent(this.map.getSize());
        var viewProps = {
          center: (0, _proj.toLonLat)(view.getCenter(), projection),
          zoom: view.getZoom(),
          extent: (0, _proj.transformExtent)(extent, projection, _constants.GEO_PROJECTION),
          projection: projection
        };

        if (!isSame(this.props.view, viewProps)) {
          this.props.onViewChange(viewProps);
        }
      }
    }
  }, {
    key: "updateMinZoom",
    value: function updateMinZoom(props) {
      var view = props.view;
      var currentView = this.map.getView();
      var minZoom = view && 'minZoom' in view ? view.minZoom : 0;

      if (currentView.getMinZoom() !== minZoom) {
        currentView.setMinZoom(minZoom);
      }
    }
  }, {
    key: "updateMaxZoom",
    value: function updateMaxZoom(props) {
      var _ref = props || this.props,
          view = _ref.view;

      var currentView = this.map.getView();

      if (view && 'maxZoom' in view) {
        var maxZoom = view.maxZoom;

        if (currentView.getMaxZoom() !== maxZoom) {
          currentView.setMaxZoom(maxZoom);
        }
      }
    }
  }, {
    key: "updateView",
    value: function updateView(props) {
      var view = this.map.getView();
      var projection = props.view && props.view.projection || view.getProjection();
      this.updateMinZoom(props);
      this.updateMaxZoom(props);

      if (!props.view || props.view.center || props.view.zoom) {
        var center, zoom;

        if (props.view && props.view.center) {
          center = (0, _proj.fromLonLat)(props.view.center, projection);
        } else {
          center = [0, 0];
        }

        if (props.view && 'zoom' in props.view) {
          zoom = props.view.zoom;
        } else {
          zoom = 0;
        }

        if (props.animation && view.isDef()) {
          view.animate(Object.assign({
            center: center,
            zoom: zoom
          }, props.animation));
        } else {
          view.setCenter(center);
          view.setZoom(zoom);
        }
      } else if (props.view.extent) {
        var extent = (0, _proj.transformExtent)(props.view.extent, _constants.GEO_PROJECTION, projection);
        view.fit(extent, view.isDef() ? props.animation : null);
      }
    }
  }, {
    key: "updateInteractions",
    value: function updateInteractions() {
      var interactive = !this.props.view || this.props.onViewChange;
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction.get(ID)) {
          interaction.setActive(interactive);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var rest = Object.assign({}, this.props);

      for (var known in Map.propTypes) {
        delete rest[known];
      }

      return _react["default"].createElement("div", rest, _react["default"].createElement("div", {
        style: {
          position: 'relative',
          height: '100%'
        }
      }, _react["default"].createElement("div", {
        ref: function ref(element) {
          return _this3.viewport = element;
        },
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0
        }
      }), _react.Children.map(this.props.children, function (child, index) {
        if (!child) {
          return child;
        }

        var props;

        if (!('zIndex' in child.props)) {
          props = {
            zIndex: index
          };
        }

        return _react["default"].cloneElement(child, props);
      })));
    }
  }]);
  return Map;
}(_react.Component);

Map.defaultProps = {
  animation: {
    duration: 250
  },
  constructorOptions: {},
  multiWorld: false
};
Map.propTypes = {
  animation: _propTypes.object,
  children: _propTypes.any,
  constructorOptions: _propTypes.object,
  innerRef: _propTypes.func,
  multiWorld: _propTypes.bool,
  onMapClick: _propTypes.func,
  onViewChange: _propTypes.func,
  onMapPointerMove: _propTypes.func,
  view: (0, _propTypes.shape)({
    center: (0, _propTypes.arrayOf)(_propTypes.number),
    zoom: _propTypes.number,
    extent: (0, _propTypes.arrayOf)(_propTypes.number),
    projection: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.instanceOf)(_Projection["default"])])
  })
};
Map.childContextTypes = {
  map: _propTypes.object.isRequired
};
var _default = Map;
exports["default"] = _default;